
import React, { useContext } from "react";
import { Box, useTheme, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { UserAuth } from "../context/AuthContext";
import Header from "./Header";
import TokenContext from "../context/TokenContext";
import TablaTrayectoria from "./tablas/TablaTrayectoria";
import { actualizarCantidades, crearTrayectoria, trayectoriaDocente } from "../Redux/trayectoriaDocente";
import { COLUMNSTRAYECTORIAS } from "../columnas/columnasTrayectorias";
import ModalTrayectorias from "./modales/ModalTrayectoria";
import { miLegajo } from "../Redux/legajo";
import ModalCantidades from "./modales/ModalCantidades";

const DocenciaUniversitaria = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const token = useContext(TokenContext);
    const { empleado } = UserAuth();

    const [trayectoria, setTrayectoria] = React.useState([])
    const trayectoriaDocenteSelector = useSelector(store => store.trayectoria.trayectoria)

    const [openModal, setOpenModal] = React.useState(false)
    const handleOpen = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);

    const [openModalRegistros, setOpenModalRegistros] = React.useState(false)
    const handleOpenRegistros = () => setOpenModalRegistros(true);
    const handleCloseRegistros = () => setOpenModalRegistros(false);

    const legajoSelector = useSelector(store => store.legajo.legajo)

    const [valores, setValores] = React.useState({})

    React.useEffect(() => {
        if (token, empleado) {
            dispatch(trayectoriaDocente(token, empleado.usuarioPortalRh))
            dispatch(miLegajo(token, empleado.empleadoid))
        }
    }, [token, empleado]);

    React.useEffect(() => {
        if (legajoSelector.length > 0) {
            const datosNuevos = {
                new_cantidadtotaldetesis: legajoSelector[0].new_cantidadtotaldetesis,
                new_cantmaestriasquedirigeactualmente: legajoSelector[0].new_cantmaestriasquedirigeactualmente,
                new_canttesinasytrabajosquedirigeactualmente: legajoSelector[0].new_canttesinasytrabajosquedirigeactualmente,
                new_canttesinasytrabfinales: legajoSelector[0].new_canttesinasytrabfinales,
                new_canttesisdoctoralesdirigactualmente: legajoSelector[0].new_canttesisdoctoralesdirigactualmente,
                new_canttesismaestriasdirigyconcult: legajoSelector[0].new_canttesismaestriasdirigyconcult,
                new_experienciaeneducacinadistancia: legajoSelector[0].new_experienciaeneducacinadistancia,
            };

            setValores(datosNuevos)
        }
    }, [legajoSelector])

    React.useEffect(() => {
        if (trayectoriaDocenteSelector?.length > 0) {
            var array = []
            trayectoriaDocenteSelector.forEach(element => {
                var objeto = {
                    id: element.new_trayectoriadocenteid,
                    new_cargo: element["new_cargo@OData.Community.Display.V1.FormattedValue"],
                    new_dedicacinsemanal: element["new_dedicacinsemanal@OData.Community.Display.V1.FormattedValue"],
                    new_designacin: element["new_designacin@OData.Community.Display.V1.FormattedValue"],
                    new_duracindelcursado: element["new_duracindelcursado@OData.Community.Display.V1.FormattedValue"],
                    new_fechadefinalizacin: element["new_fechadefinalizacin@OData.Community.Display.V1.FormattedValue"],
                    new_fechadeinicio: element["new_fechadeinicio@OData.Community.Display.V1.FormattedValue"],
                    new_unidadacadmica: element["new_unidadacadmica@OData.Community.Display.V1.FormattedValue"],
                    _new_institucinacadmica_value: element["_new_institucinacadmica_value@OData.Community.Display.V1.FormattedValue"],
                    new_tipodetrayectoria: element["new_tipodetrayectoria@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setTrayectoria(array)
        }
    }, [trayectoriaDocenteSelector])

    const handleSubmit = (datos) => {
        dispatch(crearTrayectoria(empleado.empleadoid, datos, token))
            .then((id) => {
                handleClose()
                dispatch(trayectoriaDocente(token, empleado.usuarioPortalRh))
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const handleSubmitRegistros = (datos) => {
        dispatch(actualizarCantidades(token, datos, empleado.empleadoid))
            .then((id) => {
                handleCloseRegistros()
                dispatch(miLegajo(token, empleado.empleadoid))
            })
            .catch((error) => {
                console.error("Error:", error);
            });

    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box m="1.5rem 2.5rem">
                <Header
                    title={"Docencia universitaria"}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <TablaTrayectoria columnas={COLUMNSTRAYECTORIAS} lineas={trayectoria} handleOpen={handleOpen} />

                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }} >
                        {/* Center the button using Grid */}
                        <Grid container justifyContent="center">
                            <Button color="secondary" variant="contained" onClick={handleOpenRegistros}>Editar registros</Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                        <TextField
                            color="secondary"
                            label="Cant. de Tesis Doctorales dirigidas y concluídas últimos 5 años"
                            type="number"
                            name="new_cantidadtotaldetesis"
                            value={valores.new_cantidadtotaldetesis || ''}
                            InputProps={{ style: { fontWeight: 'bold' } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                        <TextField
                            color="secondary"
                            label="Cant. de Tesis Doctorales que dirige actualmente"
                            type="number"
                            name="new_canttesisdoctoralesdirigactualmente"
                            value={valores.new_canttesisdoctoralesdirigactualmente || ''}
                            InputProps={{ style: { fontWeight: 'bold' } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                        <TextField
                            color="secondary"
                            label="Cant. de Tesis de Maestrias dirigidas y concluídas últimos 5 años"
                            type="number"
                            name="new_canttesismaestriasdirigyconcult"
                            value={valores.new_canttesismaestriasdirigyconcult || ''}
                            InputProps={{ style: { fontWeight: 'bold' } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                        <TextField
                            color="secondary"
                            label="Cant. de Tesis de Maestrías que dirige actualmente"
                            type="number"
                            name="new_cantmaestriasquedirigeactualmente"
                            value={valores.new_cantmaestriasquedirigeactualmente || ''}
                            InputProps={{ style: { fontWeight: 'bold' } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                        <TextField
                            color="secondary"
                            label="Cant. de Tesinas y Trabajos Finales dirigidas y concluídas últimos 5 años"
                            type="number"
                            name="new_canttesinasytrabfinales"
                            value={valores.new_canttesinasytrabfinales || ''}
                            InputProps={{ style: { fontWeight: 'bold' } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                        <TextField
                            color="secondary"
                            label="Cant. de Tesinas y Trabajos Finales que dirige actualmente"
                            type="number"
                            name="new_canttesinasytrabajosquedirigeactualmente"
                            value={valores.new_canttesinasytrabajosquedirigeactualmente || ''}
                            InputProps={{ style: { fontWeight: 'bold' } }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <TextField
                            color="secondary"
                            label="Experiencia en educación a distancia"
                            multiline
                            rows={4}
                            name="new_experienciaeneducacinadistancia"
                            value={valores.new_experienciaeneducacinadistancia || ''}
                            InputProps={{ style: { fontWeight: 'bold' } }}
                            fullWidth
                        />
                    </Grid>

                </Grid>

            </Box>
            <ModalTrayectorias open={openModal} handleClose={handleClose} onSubmit={handleSubmit} />
            <ModalCantidades open={openModalRegistros} handleClose={handleCloseRegistros} onSubmit={handleSubmitRegistros} />
        </motion.div>
    )
}

export default DocenciaUniversitaria